// export const BOND_DASHBOARD_API_URL =
// 'https://bond-dashboard-api.azurewebsites.net';
// export const BOND_DASHBOARD_API_URL = 'http://localhost:5001';
export const BOND_DASHBOARD_API_URL = 'https://api.ape.bond';
// export const BOND_DASHBOARD_API_URL = 'http://localhost:4000';
